module.exports = __webpack_public_path__ + "public/media/digital-vector3.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-vector3.png
// module id = ./images/services/digital-vector3.png
// module chunks = 0